// @ts-strict-ignore
import type { Status } from '@usealloy/component-library';
import { StatusValues, IconName } from '@usealloy/component-library';

interface TransactionStatus {
  backgroundColor: string;
  badgeStatus: Status;
  dotColorStart: string;
  dotColorEnd?: string;
  connectorColor: string;
  connectorStyle: 'dashed' | 'solid';
  icon?: IconName;
}

export const TRANSACTION_STATUS: {
  [key: string]: TransactionStatus;
} = {
  // Attention
  Paused: {
    backgroundColor: 'var(--cl-juicyBlue-50)',
    badgeStatus: StatusValues.info,
    dotColorStart: 'var(--cl-background-info)',
    connectorColor: 'var(--cl-gray-500)',
    connectorStyle: 'dashed',
    icon: IconName.CirclePause,
  },
  Pending: {
    backgroundColor: 'var(--cl-yellow-100)',
    badgeStatus: StatusValues.attention,
    dotColorStart: 'var(--cl-background-attention)',
    connectorColor: 'var(--cl-gray-500)',
    connectorStyle: 'dashed',
    icon: IconName.Pending,
  },

  // Danger
  Cancelled: {
    backgroundColor: 'var(--cl-red-100)',
    badgeStatus: StatusValues.danger,
    dotColorStart: 'var(--cl-background-danger)',
    connectorColor: 'var(--cl-gray-500)',
    connectorStyle: 'dashed',
    icon: IconName.Cancelled,
  },
  Declined: {
    backgroundColor: 'var(--cl-red-100)',
    badgeStatus: StatusValues.danger,
    dotColorStart: 'var(--cl-background-danger)',
    connectorColor: 'var(--cl-gray-500)',
    connectorStyle: 'dashed',
    icon: IconName.Declined,
  },
  Rejected: {
    backgroundColor: 'var(--cl-red-100)',
    badgeStatus: StatusValues.danger,
    dotColorStart: 'var(--cl-background-danger)',
    connectorColor: 'var(--cl-gray-500)',
    connectorStyle: 'dashed',
    icon: IconName.ThumbsDown,
  },
};

export const TRANSACTION_STATUS_DEFAULT: TransactionStatus = {
  backgroundColor: undefined,
  badgeStatus: StatusValues.neutral,
  dotColorStart: undefined,
  connectorColor: undefined,
  connectorStyle: 'dashed',
};

export const TRANSACTION_STATUS_SUCCESS: TransactionStatus = {
  backgroundColor: 'var(--cl-green-100)',
  badgeStatus: StatusValues.success,
  dotColorStart: 'var(--cl-background-success)',
  dotColorEnd: 'var(--cl-background-success)',
  connectorColor: 'var(--cl-background-success)',
  connectorStyle: 'solid',
  icon: IconName.ThumbsUp,
};
